// ============================================================
// OILMED — Utilitaires de navigation mensuelle
// ============================================================
// Utilisés par le sélecteur de mois (GLayout) et par les tables
// d'historique (Commandes, Journal, Libre Pratique, Douane,
// Stations) pour se limiter au mois sélectionné.
// ============================================================

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function addMonths(date, delta) {
  return new Date(date.getFullYear(), date.getMonth() + delta, 1);
}

/** @returns {{ start: Date, end: Date }} — end est exclusif (1er du mois suivant). */
export function getMonthRange(monthStart) {
  return { start: monthStart, end: addMonths(monthStart, 1) };
}

const MONTH_FORMATTER = new Intl.DateTimeFormat("fr-FR", {
  month: "long",
  year: "numeric",
});

export function formatMonthLabel(monthStart) {
  const label = MONTH_FORMATTER.format(monthStart);
  return label.charAt(0).toUpperCase() + label.slice(1);
}

/**
 * Normalise une valeur (Timestamp Firestore, Date, ISO string,
 * "dd-mm-yyyy" / "dd/mm/yyyy") en Date JS.
 */
export function toJsDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === "function") return value.toDate();
  if (typeof value === "number") return new Date(value);
  if (typeof value === "string") {
    const m = value.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
    if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) return d;
  }
  return null;
}

/** @param {{start:Date,end:Date}} range */
export function isWithinRange(value, range) {
  const d = toJsDate(value);
  if (!d || !range) return false;
  return d.getTime() >= range.start.getTime() && d.getTime() < range.end.getTime();
}
